import React, { useState, useEffect, useRef } from 'react'
import classNames from 'classnames'
import { Spacer, Button, Checkbox, Divider } from '@cleartrip/bento'
import ModalHeader from '../UserProfileModalHeader'

import { ReactComponent as InfoIcon } from 'assets/icons/info-icon.svg'
import { ReactComponent as ArrowLeft } from 'assets/icons/arrow-left.svg'
import { ReactComponent as TickFill } from 'assets/icons/successTick.svg'

import OfflineToast from 'components/GlobalNav/UserProfile/offlineToast'
import OtpBox from './otpBox'

import USER_PROFILE_PAGE_CONTANTS from '../UserProfileConstants'
const CheckYourEmail = ({ toggle, email, setPageName, clickHandler, setEmail, resendResetPassword, showCloseButton }) => {
    const animationDefaultState = { isAnimate: false, direction: 'right', isFadeIn: false }

    const refs = [useRef(), useRef(), useRef(), useRef(), useRef(), useRef()]

    const [countDown, setCountDown] = useState(0)
    const [retriesLeft, setRetriesLeft] = useState(4)
    const [animationParams, setAnimationParams] = useState(animationDefaultState)
    const [resetTrue, setResetTrue] = useState(false)
    const [isResendClicked, setIsResendClicked] = useState(false)

    const animatedClass = classNames({
        'slide-in-right': animationParams.direction === 'right' && animationParams.isAnimate,
        'slide-in-left': animationParams.direction === 'left' && animationParams.isAnimate,
        'px-8': 'px-8'
    })

    useEffect(() => {
        refs[0]?.current?.focus()
    }, [])

    return (
        <div
            className="bg-white br-4 br-4 o-hidden d-flex flex-column"
            style={{
                width: '400px',
                height: '468px'
            }}
        >
            <div className={`${animatedClass} d-flex flex-1 flex-column`}>
                <ModalHeader title={'Check your email'} toggle={toggle} showCloseButton={showCloseButton} />
                <OfflineToast page="reset password" />
                {resetTrue && (
                    <>
                        <div
                            style={{ marginBottom: '22px' }}
                            className="py-2 px-2 flex flex-middle bg-success-100  c-white fs-2 br-4"
                        >
                            <TickFill className="c-white" height={16} width={16} style={{ color: '#47991b' }} />
                            <span className="c-success-500 fs-2 fw-500 ml-1" style={{ marginTop: '1px' }}>
                                {'Link sent successfully!'}
                            </span>
                        </div>
                    </>
                )}

                <div className="d-flex flex-column flex-between flex-1">
                    <div>
                        <div className="c-pointer flex flex-middle c-secondary-500 fs-3 fw-500">
                            <div style={{ marginLeft: '-2px', marginTop: '2px' }}>
                                <ArrowLeft height={18} className="c-inherit" />
                            </div>
                            &nbsp;{' '}
                            <span
                                className="fs-2 fw-500"
                                onClick={() => {
                                    clickHandler(USER_PROFILE_PAGE_CONTANTS.RESET_PAGE, true)
                                }}
                            >
                                {'Change email'}
                            </span>
                        </div>
                        <Spacer className="pt-6" />{' '}
                        <span className="fs-3 c-neutral-700">{'We’ve sent a password reset link to '}</span>{' '}
                        <span className="fs-3 c-neutral-700 fw-600">{email}</span>
                        <Divider className="bc-grey-10 mt-4 mb-5" />
                        <div style={{ marginBottom: '29px' }}>
                            <span className="fs-2 c-neutral-700">
                                {isResendClicked
                                    ? 'Checked the spam folder but still no email?'
                                    : "Haven't received email?"}
                            </span>
                            <span
                                className={`fs-2 fw-500 ml-1 ${
                                    retriesLeft === -1
                                        ? 'c-neutral-200'
                                        : countDown !== 0
                                        ? `c-neutral-200`
                                        : 'c-blue c-pointer'
                                }`}
                                onClick={() => {
                                    let resend = resendResetPassword()
                                    setResetTrue(resend)
                                    if (resend && !isResendClicked) {
                                        setIsResendClicked(true)
                                    }
                                }}
                            >
                                {retriesLeft === -1
                                    ? 'Resend link'
                                    : countDown !== 0
                                    ? `Resend link (${countDown}s)`
                                    : 'Resend link'}
                            </span>
                        </div>
                    </div>

                    <div>
                        <Button
                            size="md"
                            type="secondary"
                            full
                            onClick={() => {
                                setPageName(USER_PROFILE_PAGE_CONTANTS.SIGNIN_PAGE)
                            }}
                        >
                            <span className="fs-3 fw-500">{'Log in to Cleartrip'}</span>
                        </Button>
                        <Spacer className="mb-8" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CheckYourEmail
